import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth, connectAuthEmulator } from "firebase/auth";
import {
  getFirestore,
  Firestore,
  connectFirestoreEmulator,
} from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";

import { env } from "../config/env";
import {
  FIREBASE_EMULATOR_CONFIG,
  FIREBASE_EMULATOR_HOSTS,
} from "../constants";

// Select config based on environment.
// NOTE: in dev+emulator mode we use demo config from constants.
const firebaseConfig =
  env.isDev && env.useEmulator ? FIREBASE_EMULATOR_CONFIG : env.firebase;

// Initialize Firebase (singleton pattern)
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0]!;
}

// Initialize services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);

// Connect to emulators in development
if (env.isDev && env.useEmulator) {
  connectAuthEmulator(auth, FIREBASE_EMULATOR_HOSTS.auth, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(
    db,
    FIREBASE_EMULATOR_HOSTS.firestore.host,
    FIREBASE_EMULATOR_HOSTS.firestore.port,
  );
}

export default app;
